import { Button } from "components";
import { useFormContext } from "react-hook-form";
import { IoIosSave } from "react-icons/io";
import toast from "react-hot-toast";
import { useApi } from "utils";
import { FormSetStockGlobalType } from "../schemas/setStockGlobalSchema";
import { PERMISION } from "security";

export function CreateSetStockGlobal(props: {
    index: number
    refecth?: () => void
}) {

     const api = useApi();

    const { getValues , trigger, formState  } = useFormContext<FormSetStockGlobalType>()

    const onSubmit  = async () => {
        const item = getValues(`items.${props.index}`)
        const isValid = await trigger(`items.${props.index}`);

        if (!isValid) {
            const errors = formState.errors?.items?.[props.index];

            if (errors) {
            Object.values(errors).forEach((err: any) => {
                if (err?.message) {
                toast.error(err.message);
                }
            });
            }
            return;
        }
    
        const cleanItem = { ...item }
        delete (cleanItem as any).location_id
      
        const data = [cleanItem]
       
        return new Promise<void>((resolve) => {
            toast.promise(
                api.post("/product/product-minmax-global/bulk-upsert", data),
                {
                    loading: "Loading...",
                    success: (res) => res.data.message,
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                //props.refecth && props.refecth();
            })
            .catch(() => {
                //handle error disini
            })
            .finally(resolve)
        })
        
    }

    return (
        <Button
            color="primary"
            permission={PERMISION.INVENTORY.TRANSACTION.SET_STOCK_GLOBAL.CREATE}
            onClick={onSubmit}
        >
            <IoIosSave size={20} />
        </Button>
    )
}